<template>
  <form
    @submit.prevent="handleSubmit"
    name="fileUpload">
    <!-- FORM UPLOAD -->
    <div
      v-if="showForm"
      class="col-sm-12 padding-off">
      <div class="col-xs-6">
        <!-- Logo -->
        <input-file
          :submitted="submitted"
          :required="true"
          @input="handleLogo"
          :label="label"
          :name="name"
          accept="image/png"
          validate="required|image"/>
        <!-- / Logo -->
      </div>

      <div
        v-if="file"
        class="col-xs-1 mt-20 padding-off">
        <button
          @click.prevent="handleShowForm"
          :disabled="loading"
          type="submit"
          class="btn btn-link btn-block btn-extra-large">
          <i class="fa fa-close"></i>
        </button>
      </div>

      <div
        :class="{ 'col-xs-5': file, 'col-xs-6': !file }"
        class="mt-20">
        <button
          :disabled="loading"
          type="submit"
          class="btn-blue btn-extra-large btn-block">
          Enviar
        </button>
      </div>
    </div>
    <!-- LOGO -->
    <div
      v-if="file && !showForm"
      class="col-sm-12">
      <div class="form-group theme-login-form-group theme-form-group">
        <label
          v-if="!showForm"
          class="mb-10">{{ label }}*</label>
        <div>
          <img
            :src="file"
            alt=""
            class="file-upload-image" />
          <button
            @click.prevent="handleShowForm"
            class="btn btn-link-underline"
            type="button">
            atualizar arquivo
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import InputFile from '@/components/fields/InputFile'

export default {
  components: {
    InputFile
  },
  props: [
    'loading',
    'file',
    'name',
    'label'
  ],
  data() {
    return {
      form: {},
      submitted: false,
      showForm: (this.file) ? false: true
    }
  },
  methods: {
    handleSubmit () {
      this.$validator.validate().then(valid => {
        this.submitted = true

        if (valid) {
          this.$emit('handleSubmit', this.form)
        }
      }).catch(() => {
        /**/
        this.submitted = false
      })
    },
    handleLogo (fileData) {
      this.form = fileData
    },
    handleShowForm () {
      this.showForm = !this.showForm
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/scss/components/forms/ScopedForms';
.file-upload-image {
  max-width: 120px;
  height: auto
}
</style>
